var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"readonly":_vm.readonly,"required":"","label":"Type*","hint":"Required. What type is this? Tequila? Whiskey? Liqueur?","persistent-hint":"","value":_vm.type,"items":_vm.types},on:{"change":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }